import React, { useState, useEffect } from "react";
import Confetti from "react-confetti"; // ✅ Imported Confetti
import "./Themes.css";

// IMPORT IMAGES
import edtech from "../assets/themes/edtech.jpg";
import cyber from "../assets/themes/cyber.jpg";
// import sustain from "../assets/themes/sustain.jpg";
import health from "../assets/themes/health.jpg";
import agri from "../assets/themes/agri.jpg";
// import smartcity from "../assets/themes/smartcity.jpg";
import blockchain from "../assets/themes/blockchain.jpg";
import open from "../assets/themes/open.jpg";

const themes = [
    { title: "EdTech", image: edtech },
    { title: "Cybersecurity & Threat Detection", image: cyber },
    { title: "HealthTech & MedTech", image: health },
    { title: "AgriTech & Rural Development", image: agri },
    { title: "Crypto & Blockchain", image: blockchain },
    { title: "Open Innovation", image: open },
];

/* =================================================
🔴 TARGET DATE CONFIGURATION
Hackathon PS Reveal on: 18 FEB 2026 — 11:45 AM IST
================================================= */
const TARGET_DATE = new Date("2026-02-18T11:45:00+05:30");

const calculateTimeLeft = () => {
    const difference = +TARGET_DATE - +new Date();
    let timeLeft = {};

    if (difference > 0) {
        timeLeft = {
            total: difference, // Track total for red glow & confetti logic
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
        };
    } else {
        timeLeft = { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return timeLeft;
};

export default function Themes() {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    const [isRevealed, setIsRevealed] = useState(false);

    // ✅ CONFETTI STATES
    const [showConfetti, setShowConfetti] = useState(false);
    const [windowSize, setWindowSize] = useState({
        width: typeof window !== "undefined" ? window.innerWidth : 1200,
        height: typeof window !== "undefined" ? window.innerHeight : 800,
    });

    useEffect(() => {
        const handleResize = () => setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (+new Date() > +TARGET_DATE) {
            setIsRevealed(true);
            return;
        }

        const timer = setInterval(() => {
            const t = calculateTimeLeft();
            setTimeLeft(t);

            if (t.total <= 0) {
                setIsRevealed(true);
                setShowConfetti(true);

                // Stop confetti after 8 seconds
                setTimeout(() => setShowConfetti(false), 8000);
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const format = (unit) => (unit < 10 ? `0${unit}` : unit);

    // Red glow triggers at 30 mins (1,800,000 ms) and stays red at 0
    const isEndingSoon = timeLeft.total <= 30 * 60 * 1000;

    return (
        <section className="themes-page">
            {/* ✅ CONFETTI */}
            {showConfetti && (
                <Confetti
                    width={windowSize.width}
                    height={windowSize.height}
                    recycle={false}
                    numberOfPieces={600}
                    style={{ position: 'fixed', top: 0, left: 0, zIndex: 9999 }}
                />
            )}

            <div className="themes-heading">
                <span className="themes-ghost">THEMES</span>
                <h2 className="hero-title themes-main-title">THEMES</h2>
            </div>

            <div className="theme-grid" style={{ marginBottom: "-20px" }}>
                {themes.map((theme, index) => (
                    <div className="theme-card" key={index}>
                        <div className="theme-face front">
                            <h3>{theme.title}</h3>
                        </div>
                        <div
                            className="theme-face back"
                            style={{ backgroundImage: `url(${theme.image})` }}
                        />
                    </div>
                ))}
            </div>

            {/* COUNTDOWN & REVEAL SECTION */}
            <div className="theme-note">
                {isRevealed ? (
                    <p style={{ marginBottom: "15px" }}>
                        <strong>🎉 Problem Statements are now revealed!</strong>
                    </p>
                ) : (
                    <p>
                        <strong>Note:</strong> <span>Problem Statements</span> will be revealed in:
                    </p>
                )}

                {/* Textless Timer */}
                <div className={`countdown-box ${isEndingSoon ? 'ending-soon' : ''}`}>
                    <span className="cd-num">{format(timeLeft.days || 0)}</span>
                    <span className="cd-sep">:</span>
                    <span className="cd-num">{format(timeLeft.hours || 0)}</span>
                    <span className="cd-sep">:</span>
                    <span className="cd-num">{format(timeLeft.minutes || 0)}</span>
                    <span className="cd-sep">:</span>
                    <span className="cd-num">{format(timeLeft.seconds || 0)}</span>
                </div>

                {/* ✅ REVEALED BUTTONS (Word Doc & Google Form) */}
                {isRevealed ? (
                    <div className="reveal-actions">
                        <a
                            href="PROBLEM STATEMENTS (HACK KRMU 5).pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="action-btn doc-btn"
                        >
                            📄 Download PS Doc
                        </a>
                        <a
                            href="https://docs.google.com/forms/d/e/1FAIpQLSdhOOqA7jBRtrW0-pwknxV2ConMzJuFPi532ZEzlCdnvNLFmg/viewform?usp=dialog"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="action-btn form-btn"
                        >
                            ✅ Select Your PS
                        </a>
                    </div>
                ) : (
                    <p style={{ marginTop: "15px", fontSize: "0.85rem", opacity: 0.7 }}>
                        Links to download the Problem Statements and select your theme will appear here.
                    </p>
                )}
            </div>
        </section>
    );
}